import React, { useState, useEffect } from 'react';
import { Box, Button, Typography, Table, TableBody, CircularProgress } from '@mui/material';
import axios from 'axios';
import toast from 'react-hot-toast';
import { useHistory } from 'react-router-dom';
import ErrorFallback from 'components/error-fallback';
import { ErrorBoundary } from 'react-error-boundary';
import { endPoints } from 'pages/dlops-dashboard/api/endpoint';
import { commonStyles as styles } from 'assets/style';
import { ProgressIcon } from '../style';
import AccessToken from '../components/accessToken/accessToken';
import TeamMemberDrawer from './createTeamMembers';
import Header from './createNewModelTags/Header';
import { SubmitDialog, DeleteDialog } from './createNewModelTags/DialogBox';
import MetaDataTags from './createNewModelTags/MetaDataTags';
import SmartFilteringTags from './createNewModelTags/SmartFilteringTags';
import SmartSamplingTags from './createNewModelTags/SmartSamplingTags';
import RetrainingTags from './createNewModelTags/RetrainingTags';

const CreateNewModelTags = () => {
    const { getAccessToken } = AccessToken();
    const [addtags, setAddTags] = useState([]);
    const history = useHistory();
    const [isAllChecked, setIsAllChecked] = useState(false);
    const [deleteOpenPopUp, setDeletePopUp] = useState(false);
    const [deleteIndex, setDeleteIndex] = useState(null);
    const [allSelected, setAllSelected] = useState(false);
    const [errors, setErrors] = useState({});
    const [smartSamplingTagsErrors, setSmartSamplingTagsErrors] = useState({});
    const [smartFilteringErrors, setSmartFilteringErrors] = useState({});
    const [retrainingTagsErrors, setRetrainingTagsErrors] = useState({});
    const [openPopup, setOpenPopup] = useState(false);
    const [popupMessage, setPopupMessage] = useState('');
    const [isLoading, setLoading] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);
    const [showAccessFields, setShowAccessFields] = useState(false);
    const [isSmartFilteringEnabled, setIsSmartFilteringEnabled] = useState(false);
    const moduleInfo = JSON.parse(localStorage.getItem('modelFormData')) || {};
    const modelTypeTag = moduleInfo?.tags?.find((tag) => tag.mkey === 'model_type');
    const isSegmentation = modelTypeTag?.mvalue === 'segmentation';
    // eslint-disable-next-line no-unused-vars
    const [openDrawer, setOpenDrawer] = useState(false);
    const [tags, setTags] = useState([
        {
            name: 'BaseLine Datasource',
            mkey: 'baseline_datasource',
            tooltipInfo: 'A URL that provides access to a CSV file containing details about the training dataset used for the model',
            mvalue: '',
        },
        {
            name: 'Baseline Datasource Version',
            mkey: 'baseline_datasource_version',
            tooltipInfo:
                'The version number of the baseline datasource, indicating the specific iteration or update of the CSV file containing the training dataset details',
            mvalue: '',
        },
        {
            name: 'Storage Account',
            mkey: 'storage_account',
            tooltipInfo:
                'An identifier for the cloud storage account used to store data and files associated with the project, including models, datasets, and other resources',
            mvalue: '',
        },
        {
            name: 'Market',
            mkey: 'market',
            tooltipInfo:
                'The specific market or environment in which the model is being deployed for use, indicating the target audience or application context',
            mvalue: '',
        },
        {
            name: 'Container Name',
            mkey: 'container_name',
            tooltipInfo: 'The name of the storage container used to organize and manage data and files within a cloud storage account',
            mvalue: '',
        },
        { name: 'Framework', mkey: 'framework', tooltipInfo: 'The software framework or library used to develop and implement the model', mvalue: '' },
        {
            name: 'Drift Distance Threshold',
            mkey: 'drift_distance_threshold',
            tooltipInfo:
                'Set the threshold value for the drift monitor. If the drift distance exceeds this value, the monitor will trigger. The default value as per Arize is 2.',
            mvalue: 2,
        },
    ]);

    const [retrainingTags, setRetrainingTags] = useState([
        {
            name: 'Retraining Storage Account',
            mkey: 'retraining_storage_acc_name',
            tooltipInfo: 'Name of the Azure Storage Account.',
            mvalue: '',
        },
        {
            name: 'Retraining Container',
            mkey: 'retraining_container_name',
            tooltipInfo: 'Name of the blob container to store drifted images.',
            mvalue: '',
        },
        {
            name: 'Retraining Destination Path',
            mkey: 'retraining_blob_path',
            tooltipInfo: 'Subdirectory within the container where images will be saved.',
            mvalue: '',
        },
        {
            name: 'Retraining SAS Token',
            mkey: 'retraining_sas_token',
            tooltipInfo: 'Shared Access Signature token for secure access.',
            mvalue: '',
        },
    ]);
    const [smartSampling, setSmartSampling] = useState([
        {
            name: 'Source Account',
            mkey: 'source_account',
            tooltipInfo: 'Source storage account for smart sampling.',
            mvalue: '',
        },
        {
            name: 'Source Container',
            mkey: 'source_container',
            tooltipInfo: 'Source container for smart sampling.',
            mvalue: '',
        },
        {
            name: 'Source Subpath',
            mkey: 'source_subpath',
            tooltipInfo: 'Source subpath for smart sampling.',
            mvalue: '',
        },
        {
            name: 'Output Account',
            mkey: 'output_account',
            tooltipInfo: 'Output storage account for smart sampling.',
            mvalue: '',
        },
        {
            name: 'Output Container',
            mkey: 'output_container',
            tooltipInfo: 'Output container for smart sampling.',
            mvalue: '',
        },
        {
            name: 'Output Subpath',
            mkey: 'output_subpath',
            tooltipInfo: 'Output subpath for smart sampling.',
            mvalue: '',
        },
    ]);
    const [smartFiltering, setSmartFiltering] = useState([
        {
            name: 'Exported CSV File Location',
            mkey: 'output_csv_path',
            tooltipInfo: 'Defines the location where the new CSV file, generated after the smart filtering process, will be stored.',
            mvalue: '',
            helpText: 'Example: https://storageaccount.blob.core.windows.net/container-name/folder/file.csv',
        },
        {
            name: 'Processed Images Folder Path',
            mkey: 'images_output_path',
            tooltipInfo: 'Specifies the directory used to store the compressed (JPEG) images produced during the smart filtering process.',
            mvalue: '',
            helpText: 'Example: https://storageaccount.blob.core.windows.net/container-name/folder',
        },
    ]);
    useEffect(() => {
        const savedDefaultTags = localStorage.getItem('createDefaulttags');
        const savedNewlyAddedTags = localStorage.getItem('newlyAddedtags');
        if (savedDefaultTags) {
            const allTagsData = JSON.parse(savedDefaultTags);
            setTags(allTagsData.tags || []);
            setIsSmartFilteringEnabled(allTagsData.isSmartFilteringEnabled || false);
        }

        if (savedNewlyAddedTags) {
            setAddTags(JSON.parse(savedNewlyAddedTags));
        }
    }, []);

    const handleAddNewRow = () => {
        setAddTags([...addtags, { name: '', type: '', value: '', checked: false }]);
    };
    const handleClosePopup = () => {
        setOpenPopup(false);
        setShowAccessFields(false);
        if (isSuccess) {
            localStorage.removeItem('create_project');
            localStorage.removeItem('modelFormData');
            localStorage.removeItem('createNewtags');
            history.push('/pepvigil-projects');
        }
    };
    const handleCancel = () => {
        history.push('/pepvigil-projects');
    };
    const handleBack = () => {
        history.push('/pepvigil-new-modelCreation');
    };
    const handleInputChange = (index, field, value) => {
        const updatedTags = [...tags];
        updatedTags[index][field] = value;
        setTags(updatedTags);

        // Clear error if input is filled
        if (value) {
            setErrors((prevErrors) => {
                const newErrors = { ...prevErrors };
                delete newErrors[index]; // Remove the error for this index
                return newErrors;
            });
        }
    };
    const handleRetrainingInputChange = (index, field, value) => {
        const updatedTags = [...retrainingTags];
        updatedTags[index][field] = value;
        setRetrainingTags(updatedTags);

        // Clear error if input is filled
        if (value) {
            setRetrainingTagsErrors((prevErrors) => {
                const newErrors = { ...prevErrors };
                delete newErrors[`retraining_${index}`]; // Remove the error for this index
                return newErrors;
            });
        }
    };

    const handleNavigation = () => {
        history.push('/pepvigil-projects');
    };
    const handleInputTags = (index, field, value) => {
        const updatedRows = addtags.map((row, i) => (i === index ? { ...row, [field]: value } : row));
        setAddTags(updatedRows);
    };
    const handleRowCheck = (index) => {
        const updatedRows = addtags.map((row, i) => (i === index ? { ...row, isChecked: !row.isChecked } : row));
        setAddTags(updatedRows);
    };

    const handleDeleteRow = (index) => {
        setDeleteIndex(index);
        setDeletePopUp(true);
    };
    const deleteRow = (index) => {
        const updatedRows = addtags.filter((_, i) => i !== index);
        setAddTags(updatedRows);
    };
    const handleCancelDelete = () => {
        setDeletePopUp(false);
    };
    const handleDeleteAllSelected = () => {
        setDeletePopUp(true);
        setDeleteIndex('SelectedAll');
    };
    const handleSelectAll = (event) => {
        const { checked } = event.target;
        setAllSelected(checked);
        setIsAllChecked(checked);
        setAddTags(addtags.map((row) => ({ ...row, checked, isChecked: checked })));
    };
    const handleConfirmDelete = () => {
        if (deleteIndex === 'SelectedAll') {
            setAddTags(addtags.filter((row) => !row.isChecked));
        } else {
            deleteRow(deleteIndex);
        }
        setDeletePopUp(false);
        setAllSelected(false);
        setIsAllChecked(false);
    };
    // // Helper function to validate URLs
    const isValidURL = (url) => {
        const pattern = /^https:\/\/[a-zA-Z0-9_-]+\.blob\.core\.windows\.net\/[a-zA-Z0-9_-]+(\/[a-zA-Z0-9_.-]+)*\/[a-zA-Z0-9_.-]+\.[a-z]+$/;
        return pattern.test(url);
    };
    if (isLoading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: '100vh' }}>
                <CircularProgress color="inherit" size={16} sx={ProgressIcon.circularProgressColor} />
                <Typography variant="body2" sx={ProgressIcon.circularProgressColor} style={{ marginLeft: '10px' }}>
                    Loading
                </Typography>
            </Box>
        );
    }
    const handleSamplingInputChange = (index, field, value) => {
        const updatedTags = [...smartSampling];
        updatedTags[index][field] = value;
        setSmartSampling(updatedTags);

        // Clear error if input is filled
        if (value) {
            setSmartSamplingTagsErrors((prevErrors) => {
                const newErrors = { ...prevErrors };
                delete newErrors[`sampling_${index}`]; // Remove the error for this index
                return newErrors;
            });
        }
    };
    const handleSmartFilteringInputChange = (index, field, value) => {
        const updatedTags = [...smartFiltering];
        updatedTags[index][field] = value;
        setSmartFiltering(updatedTags);

        const otherIndex = index === 0 ? 1 : 0;
        const otherFieldValue = updatedTags[otherIndex].mvalue; // Use updatedTags instead of smartFiltering

        // Clear errors for both fields first
        setSmartFilteringErrors((prevErrors) => {
            const newErrors = { ...prevErrors };
            delete newErrors[index];
            delete newErrors[otherIndex];
            return newErrors;
        });

        // Set new errors if needed
        if (value.trim() && !otherFieldValue.trim()) {
            setSmartFilteringErrors((prevErrors) => ({
                ...prevErrors,
                [otherIndex]: 'This field is required when other smart filtering fields are filled.',
            }));
        }

        // Validate URL for output_csv_path
        if (updatedTags[index].mkey === 'output_csv_path' && value && !isValidURL(value)) {
            setSmartFilteringErrors((prevErrors) => ({
                ...prevErrors,
                [index]: 'Please enter a valid CSV file URL.',
            }));
        }
    };

    const handleValidation = () => {
        let formIsValid = true;
        const newErrors = {};
        const newRetrainingTagsErrors = {};
        const newSmartSamplingTagsErrors = {};
        const smartFilteringTagsErrors = {};
        if (isSmartFilteringEnabled) {
            const filledFieldsCount = smartFiltering.filter((tag) => tag.mvalue.trim() !== '').length;
            smartFiltering.forEach((tag, index) => {
                const isFieldEmpty = !tag.mvalue.trim();
                const otherFieldsFilled = filledFieldsCount > (isFieldEmpty ? 0 : 1); // Check if other fields are filled

                if (isFieldEmpty && otherFieldsFilled) {
                    formIsValid = false;
                    smartFilteringTagsErrors[index] = 'This field is required when smart filtering is enabled and other fields are filled.';
                } else if (tag.mkey === 'output_csv_path' && tag.mvalue && !isValidURL(tag.mvalue)) {
                    formIsValid = false;
                    smartFilteringTagsErrors[index] = 'Please enter a valid CSV file URL.';
                }
            });
        }
        tags.forEach((tag, index) => {
            switch (tag.mkey) {
                case 'baseline_datasource':
                    if (!tag.mvalue) {
                        formIsValid = false;
                        newErrors[index] = 'Baseline datasource is required.';
                    } else if (!isValidURL(tag.mvalue)) {
                        formIsValid = false;
                        newErrors[index] = 'Please enter a valid URL.';
                    }
                    break;
                case 'output_csv_path':
                    if (!isValidURL(tag.mvalue)) {
                        formIsValid = false;
                        newErrors[index] = 'Please enter a valid URL.';
                    }
                    break;
                case 'images_output_path':
                    if (!isValidURL(tag.mvalue)) {
                        formIsValid = false;
                        newErrors[index] = 'Please enter a valid URL.';
                    }
                    break;

                case 'baseline_datasource_version':
                    if (!tag.mvalue) {
                        formIsValid = false;
                        newErrors[index] = 'Baseline datasource version is required.';
                    } else if (!/^\d+(\.\d+)?$/.test(tag.mvalue)) {
                        formIsValid = false;
                        newErrors[index] = 'Please enter a valid number or decimal.';
                    }
                    break;
                case 'desc_version':
                    if (!tag.mvalue) {
                        formIsValid = false;
                        newErrors[index] = 'Description version is required.';
                    }
                    break;
                case 'description_model':
                case 'storage_account':
                case 'market':
                case 'container_name':
                case 'framework':
                    if (!tag.mvalue) {
                        formIsValid = false;
                        newErrors[index] = `${tag.mkey.replace(/_/g, ' ')} is required.`;
                    }
                    break;
                case 'drift_distance_threshold': {
                    const thresholdValue = Number(tag.mvalue);

                    if (Number.isNaN(thresholdValue) || thresholdValue < 0.5 || thresholdValue > 5) {
                        formIsValid = false;
                        newErrors[index] = 'Please enter a number between 0.5 and 5';
                    }
                    break;
                }
                default:
                    break;
            }
        });

        addtags.forEach((tag, index) => {
            if (!tag.name) {
                formIsValid = false;
                newErrors[`add_${index}_name`] = 'Name is required.';
            }
            if (!tag.value) {
                formIsValid = false;
                newErrors[`add_${index}_value`] = 'Value is required.';
            }
        });

        // Validation for Retraining Data Storage Configuration
        retrainingTags.forEach((tag, index) => {
            if (!tag.mvalue || tag.mvalue.trim() === '') {
                formIsValid = false;
                newRetrainingTagsErrors[`retraining_${index}`] = `${tag.name} is required.`;
            } else {
                const fieldValue = tag.mvalue.trim();
                let errorMessage = '';

                switch (tag.mkey) {
                    case 'retraining_storage_acc_name':
                        if (fieldValue.length < 3 || fieldValue.length > 24) {
                            errorMessage = 'Storage Account should be between 3-24 characters.';
                        }
                        break;

                    case 'retraining_container_name':
                        // Basic container name validation
                        if (fieldValue.length < 3 || fieldValue.length > 63) {
                            errorMessage = 'Container should be between 3-63 characters.';
                        }
                        break;

                    case 'retraining_blob_path':
                        // Basic path validation
                        if (fieldValue.length === 0) {
                            errorMessage = 'Destination Path cannot be empty.';
                        } else if (fieldValue.includes('//')) {
                            errorMessage = 'Destination Path cannot contain consecutive slashes.';
                        }
                        break;

                    case 'retraining_sas_token':
                        // Basic SAS token validation
                        if (fieldValue.length < 20) {
                            errorMessage = 'SAS Token appears to be too short.';
                        }
                        break;

                    default:
                        break;
                }

                if (errorMessage) {
                    formIsValid = false;
                    newRetrainingTagsErrors[`retraining_${index}`] = errorMessage;
                }
            }
        });
        if (isSegmentation) {
            smartSampling.forEach((tag, index) => {
                if (!tag.mvalue) {
                    formIsValid = false;
                    newSmartSamplingTagsErrors[`sampling_${index}`] = `${tag.mkey.replace(/_/g, ' ')} is required.`;
                }
            });
        } else {
            Object.keys(newSmartSamplingTagsErrors).forEach((key) => delete newSmartSamplingTagsErrors[key]);
        }
        setErrors(newErrors);
        setRetrainingTagsErrors(newRetrainingTagsErrors);
        setSmartSamplingTagsErrors(newSmartSamplingTagsErrors);
        setSmartFilteringErrors(smartFilteringTagsErrors);
        return formIsValid;
    };

    const saveNewProjectCreation = async (accessTokenPromise, payload) => {
        try {
            const accessToken = await accessTokenPromise;
            const response = await axios.post(endPoints.submitCreateNewProject, payload, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    Accept: 'application/json',
                },
            });
            return response?.data;
        } catch (error) {
            return error;
        }
    };
    const handleSaveTags = async () => {
        if (handleValidation()) {
            localStorage.setItem('createDefaulttags', JSON.stringify(tags));
            localStorage.setItem('newlyAddedtags', JSON.stringify(addtags)); // This seems to be saving the same data as above.
            toast.success('Meta Data Tags Saved Successfully', {
                position: 'top-right',
                autoClose: 3000,
            });
        }
    };
    const handleSubmit = async () => {
        if (handleValidation()) {
            // Proceed with the submission
            const tagsToSave = tags.map(({ mkey, mvalue }) => ({ mkey, mvalue }));
            const retrainingTagsToSave = retrainingTags.map(({ mkey, mvalue }) => ({ mkey, mvalue }));
            localStorage.setItem('createNewtags', JSON.stringify(tagsToSave));
            localStorage.setItem('createNewRetrainingTags', JSON.stringify(retrainingTagsToSave));

            const createProject = JSON.parse(localStorage.getItem('create_project')) || {};
            const modelFormData = JSON.parse(localStorage.getItem('modelFormData')) || {};
            const tagsFromStorage = JSON.parse(localStorage.getItem('createNewtags')) || [];
            const retrainingTagsFromStorage = JSON.parse(localStorage.getItem('createNewRetrainingTags')) || [];
            const projectNameTag = {
                mkey: 'project_name',
                mvalue: createProject.project_name,
            };
            const addNewtagsToSave = addtags.map(({ name, value }) => ({
                mkey: name,
                mvalue: value,
            }));
            const payload = {
                project_name: createProject.project_name || '',
                new_project: createProject.new_project || false,
                project_desc: createProject.project_desc || '',
                project_createdby: createProject.project_createdby || '',
                project_createdby_user_details: createProject.project_createdby_user_details,
                model_name: modelFormData.model_name || '',
                model_version: String(modelFormData.model_version) || '',
                model_desc: modelFormData.model_desc || '',
                model_createdby: modelFormData.model_createdby || '',
                model_createdby_user_details: modelFormData.model_createdby_user_details,
                model_current_stage: modelFormData.model_current_stage,
                tags: [...tagsFromStorage, ...modelFormData.tags, projectNameTag, ...addNewtagsToSave, ...retrainingTagsFromStorage],
            };
            try {
                setLoading(true);
                const response = await saveNewProjectCreation(getAccessToken(), payload);
                if (response && response.Response === 'Success') {
                    setPopupMessage(
                        <>
                            Project onboarded successfully.
                            {/* To access the DLops project, please reach out to our DLOps dedicated team at{' '}
                            <a href="mailto:dl-pepeedlops@pepsico.com" style={{ color: '#1378D4' }}>
                                dl-pepeedlops@pepsico.com
                            </a>
                            . */}
                        </>
                    );
                    setIsSuccess(true);
                } else {
                    setPopupMessage('Failed to create project.');
                    setIsSuccess(false);
                }
                setLoading(false);
                setOpenPopup(true);
            } catch (error) {
                setPopupMessage('Error saving data.');
                setIsSuccess(false);
                setLoading(false);
                setOpenPopup(true);
            }
        }
    };
    const handleAddTeamMembers = () => {
        setOpenDrawer(true);
        setOpenPopup(false);
    };
    const handleDrawerSubmit = () => {
        // You can handle any logic after submitting the drawer form
        setIsSuccess(true);
        history.push('/pepvigil-projects');
        // setPopupMessage('Team member added successfully!');
    };
    const handleDrawerClose = () => {
        setOpenDrawer(false);
        history.push('/pepvigil-projects');
    };

    return (
        <ErrorBoundary FallbackComponent={ErrorFallback}>
            <Header handleNavigation={handleNavigation} handleBack={handleBack} />
            <Box className="contentContainer">
                <Box
                    sx={{
                        height: '70px',
                        background: '#FFFFFF 0% 0% no-repeat padding-box',
                        borderRadius: '4px',
                        marginTop: '20px',
                        padding: '16px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                    }}
                >
                    <Typography sx={{ fontSize: '18px', fontWeight: '700', color: '#005CBC' }}>Create New Model Tags</Typography>
                </Box>
                <SubmitDialog
                    open={openPopup}
                    onClose={handleClosePopup}
                    isSuccess={isSuccess}
                    message={popupMessage}
                    onAddTeamMembers={handleAddTeamMembers}
                    showAccessFields={showAccessFields}
                />
                <TeamMemberDrawer open={openDrawer} onClose={handleDrawerClose} onSubmit={handleDrawerSubmit} sx={{ width: '90%' }} />
                <Box
                    sx={{
                        background: '#FFFFFF 0% 0% no-repeat padding-box',
                        borderRadius: '4px',
                        marginTop: '20px',
                        padding: '16px',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                    }}
                >
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                        <Table>
                            <TableBody>
                                <MetaDataTags
                                    tags={tags}
                                    addtags={addtags}
                                    errors={errors}
                                    isAllChecked={isAllChecked}
                                    allSelected={allSelected}
                                    handleInputChange={handleInputChange}
                                    handleInputTags={handleInputTags}
                                    handleAddNewRow={handleAddNewRow}
                                    handleSaveTags={handleSaveTags}
                                    handleDeleteAllSelected={handleDeleteAllSelected}
                                    handleRowCheck={handleRowCheck}
                                    handleDeleteRow={handleDeleteRow}
                                    handleSelectAll={handleSelectAll}
                                />
                                <SmartFilteringTags
                                    isSmartFilteringEnabled={isSmartFilteringEnabled}
                                    setIsSmartFilteringEnabled={setIsSmartFilteringEnabled}
                                    smartFiltering={smartFiltering}
                                    smartFilteringErrors={smartFilteringErrors}
                                    handleSmartFilteringInputChange={handleSmartFilteringInputChange}
                                />
                                {isSegmentation && (
                                    <SmartSamplingTags
                                        smartSampling={smartSampling}
                                        smartSamplingTagsErrors={smartSamplingTagsErrors}
                                        handleSamplingInputChange={handleSamplingInputChange}
                                    />
                                )}
                                <RetrainingTags
                                    retrainingTags={retrainingTags}
                                    retrainingTagsErrors={retrainingTagsErrors}
                                    handleRetrainingInputChange={handleRetrainingInputChange}
                                />
                            </TableBody>
                        </Table>

                        <Box sx={{ display: 'flex', gap: '10px' }}>
                            <Button
                                disableElevation
                                disableRipple
                                variant="contained"
                                sx={{ ...styles.primaryMediumButton, marginTop: '50px' }}
                                onClick={handleBack}
                            >
                                Back
                            </Button>
                            <Button
                                disableElevation
                                disableRipple
                                variant="outlined"
                                sx={{ ...styles.secondaryMediumButton, marginTop: '50px' }}
                                onClick={handleCancel}
                            >
                                Cancel
                            </Button>
                            <Button
                                disableElevation
                                disableRipple
                                variant="contained"
                                sx={{ ...styles.primaryMediumButton, marginTop: '50px', marginLeft: '500px' }}
                                onClick={handleSubmit}
                            >
                                Submit
                            </Button>
                        </Box>
                    </Box>
                </Box>
                <DeleteDialog open={deleteOpenPopUp} onCancel={handleCancelDelete} onConfirm={handleConfirmDelete} />
            </Box>
        </ErrorBoundary>
    );
};

export default CreateNewModelTags;
